<template>
  <Teleport to="body">
    
    <transition name="slide-up">
      <div v-if="visible" class="fixed bottom-0 left-0 right-0 z-[200] bg-white rounded-t-2xl shadow-xl h-[90vh] flex flex-col overflow-hidden">
        <!-- Drag Handle / Header -->
         
        
        <!-- Content -->
        <div class="flex-1 overflow-hidden relative bg-gray-50">
           <component 
              v-if="currentDetailComponent"
              :is="currentDetailComponent"
              :id="approvalId"
              :is-modal="true"
              @close="close"
              @refresh="$emit('refresh')"
              class="h-full overflow-y-auto"
            />
           <div v-else class="p-8 text-center text-gray-500 flex flex-col items-center justify-center h-full">
             <i class="fas fa-question-circle text-4xl mb-3 text-gray-300"></i>
             <p>暂不支持预览该类型审批</p>
             <p class="text-xs mt-1">{{ businessType || '未知类型' }}</p>
           </div>
        </div>
      </div>
    </transition>
  </Teleport>
</template>

<script setup>
import { computed } from 'vue'
import PaymentDetail from '@/mobile/views/Approval/PaymentDetail.vue'
import InvoiceDetail from '@/mobile/views/Approval/InvoiceDetail.vue'
import SealDetail from '@/mobile/views/Approval/SealDetail.vue'

const props = defineProps({
  visible: Boolean,
  item: {
    type: Object,
    default: () => ({})
  }
})

const emit = defineEmits(['update:visible', 'close', 'refresh'])

const close = () => {
  emit('update:visible', false)
  emit('close')
}


const approvalId = computed(() => props.item?.id || props.item?.instanceId || props.item?.businessKey)
const businessType = computed(() => props.item?.businessType)

const currentDetailComponent = computed(() => {
  const type = businessType.value
  if (!type) return null
  
  const t = String(type).trim().toLowerCase()
  const normalizedType = t.replace(/\s+/g, '')
  
  if (t === '付款申请' || t === '付款申请(小额)' || normalizedType === '付款申请(小额)' || t === 'payment') return PaymentDetail
  if (t === '开票申请' || t === '开票申请(小额)' || normalizedType === '开票申请(小额)' || t === 'invoice') return InvoiceDetail
  if (t === '公章申请' || t === '公章申请(合同)' || t === 'seal') return SealDetail
  
  return null
})
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.slide-up-enter-from,
.slide-up-leave-to {
  transform: translateY(100%);
}
</style>
